import { createFileRoute } from '@tanstack/react-router'

import { CompanySettings } from '@/company/components/CompanySettings/CompanySettings'

export const Route = createFileRoute('/company/_management/settings/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <CompanySettings />
}
